import PressCard from "./PressCard";

export default PressCard;
